export const convertArrayToObjectBySpecificKey = (array: any[], key: string) => {
    return array.reduce((acc, curr) => {
        acc[curr[key]] = curr;
        return acc;
    }, {} as Record<string, any>);
};
